function Home() {
    return  <div>
        <div>
            <h1 className="text-4xl text-center text-white mt-3">Willkommen auf meiner Website</h1>
        </div>
        <div>
            <table>
                <thead>
                    <tr><th>Test 1</th><th>Test 2</th></tr>
                </thead>
                <tbody>
                    <tr><td>Hallo</td></tr>
                </tbody>
            </table>
        </div>
        </div>
}

export default Home;